// extracted by mini-css-extract-plugin
module.exports = {"container":"e_A4","anchor":"e_B4"};